require('../bootstrap');
require('../directives');

Vue.component('cookie-consent', require('./../src/components/Cookie/CookieConsent').default);
Vue.component('cookie-setup', require('./../src/components/Cookie/CookieSetup').default);
Vue.component('share-buttons', require('./../src/components/ShareButtons').default);
Vue.component('storage-tank-calculator', require('./../src/components/StorageTankCalculator').default);

import Form from './../src/core/Form';
import Slider from './../src/core/Slider';
import Gallery from './../src/core/Gallery';
import OffCanvasNavigation from './../src/core/OffCanvasNavigation';

new Vue({
    el: '#app',
    mounted() {
        document.body.addEventListener('click', event => window.EventHandler.fire('body-clicked', event));
        new Form;
        new Slider;
        new Gallery;
        new OffCanvasNavigation;
    }
});